/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_DescriptionInputs */

const en_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposit into your portfolio and start Gliding.`)
};

const de_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahle in dein Portfolio ein und starte mit Glider.`)
};

const pt_br2_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposite no seu portfólio e comece a usar o Glider.`)
};

const tr_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyüne para yatır ve Glider'ı kullanmaya başla.`)
};

const zh_cn2_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向投资组合存入资金，开始使用 Glider。`)
};

const zh_hk2_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向投資組合存入資金，開始使用 Glider。`)
};

const ko_kr2_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오에 입금하고 Glider를 시작하세요.`)
};

const ru_ru2_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внесите средства в портфель и начните работу с Glider.`)
};

const es_419_onboarding_v1_fund_description = /** @type {(inputs: Onboarding_V1_Fund_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposita en tu portafolio y empieza a usar Glider.`)
};

/**
* | output |
* | --- |
* | "Deposit into your portfolio and start Gliding." |
*
* @param {Onboarding_V1_Fund_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_description = /** @type {((inputs?: Onboarding_V1_Fund_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_description(inputs)
	if (locale === "de") return de_onboarding_v1_fund_description(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_description(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_description(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_description(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_description(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_description(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_description(inputs)
	return es_419_onboarding_v1_fund_description(inputs)
});